// extracted by mini-css-extract-plugin
export default {"ourProjects":"projectsPage_ourProjects__c8OZe","ourProjectsDesc":"projectsPage_ourProjectsDesc__63kyk"};